import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from '../../features/user';
//import cookie from "js-cookie";
import { useTranslation } from 'react-i18next';
//import { useSearchParams } from "react-router-dom";
import {checkValidToken} from "../../Helper"
import Frame from '../widgets/Frame';
import { isFeatureOn, tBrand } from "../../portalSettings";
// import axios from "axios";
// import { API_OK, API_URL} from '../../Constants';


export function Start() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    //const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const reseller = useSelector((state) => state.reseller.value);

    /**
     * שני הכפתורים - הרשמה והתחברות - לפי מה שפתוח אצל הריסיילר.
     *
     * ריסיילר שההרשמה סגורה בו מקבל מסך עם כפתור אחד, ולא כפתור שמוביל למסך שמפנה
     * חזרה: הפניה שקורית אחרי לחיצה נראית כמו תקלה, גם כשהיא נכונה.
     */
    const showRegister = isFeatureOn(reseller, 'allowRegistration');

    useEffect(() => {
        checkValidToken(navigate, dispatch, logout);
        // eslint-disable-next-line  
    }, []);



    const handleRegesterClick = (e) => {
        navigate("/register");
    };

    const handleLoginClick = (e) => {
        navigate("/login");
    }; 

    


    return (
            <Frame>
                <div className='main main-start'>
                    <div className='main-top'>
                        <h1>{tBrand(t, "Welcome to Yemot Hamashiach, the advanced communication solutions company", reseller)}</h1>
                    </div>
                    <div className='main-body'>
                        <div className='right-main'>
                            <div className='right-main-inner'>
                                <h2>{t("We are happy that you chose us")}</h2>
                                <h2>{t(showRegister?"To begin, please select the right option for you":"Please insert the username for login")}</h2>
                                {showRegister&&<div className='mt30'><div className='button blue-border' onClick={(e) => handleRegesterClick(e)}><img src='/images/register-icon.png' className='button-icon' alt=''/> {t("Registration")} </div></div>}
                                <div className={showRegister?'':'mt30'}><div className='button blue-border' onClick={(e) => handleLoginClick(e)}><img src='/images/login-icon.png' className='button-icon' alt=''/> {t("Login")} </div></div>
                            </div>
                        </div>
                        <div className='left-main'>
                            <img src='/images/person-phone.png' className='content-logo' alt=''/>
                        </div>
                    </div>
                </div>
            </Frame>
    );
}